import { getEnvConfig } from 'config/environment';

import itaConfig from './ita.config';
import soloConfig from './solo.config';
import testConfig from './test.config';
import { AppClient, type ClientConfig, type Feature } from './types';
import ustaConfig from './usta.config';

export const getClientConfig = (): ClientConfig => {
  switch (getActiveClient()) {
    case AppClient.USTA:
      return ustaConfig;
    case AppClient.ITA:
      return itaConfig;
    case AppClient.SOLO:
      return soloConfig;
    case AppClient.TEST:
      return testConfig;
    default:
      throw Error('Missing client configuration. REACT_APP_ACTIVE_CLIENT has no associated config.');
  }
};

// We want to use this as little as possible in the code, it is an escape hatch
export const getActiveClient = (): AppClient => {
  const client: AppClient = getEnvConfig().REACT_APP_ACTIVE_CLIENT as AppClient;
  if (!client) throw Error('Missing client configuration. REACT_APP_ACTIVE_CLIENT must be specified');
  return client;
};

export const featureEnabled = (feature: Feature) => {
  return !getClientConfig().disableFeatures?.includes(feature);
};

/**
 * For optionally including an array element. Makes sure you spread this!
 * [<item1>, ...includeIfFeatureEnabled(<feature>, <item2>), <item3>]
 **/
export const includeIfFeatureEnabled = (feature: Feature, thingToInclude: any, thingToBeTrue = true) => {
  return featureEnabled(feature) && thingToBeTrue ? [thingToInclude] : [];
};
